import { Activities, jobWorkflowStage, jobs } from '../CandidateView/actions'

export const REJECT_CANDIDATE = 'REJECT_CANDIDATE'
export const REJECT_CANDIDATE_PENDING = 'REJECT_CANDIDATE_PENDING'
export const REJECT_CANDIDATE_FULFILLED = 'REJECT_CANDIDATE_FULFILLED'
export const REJECT_CANDIDATE_REJECTED = 'REJECT_CANDIDATE_REJECTED'

export const DELETE_CANDIDATE = 'DELETE_CANDIDATE'
export const DELETE_CANDIDATE_PENDING = 'DELETE_CANDIDATE_PENDING'
export const DELETE_CANDIDATE_FULFILLED = 'DELETE_CANDIDATE_FULFILLED'
export const DELETE_CANDIDATE_REJECTED = 'DELETE_CANDIDATE_REJECTED'

export const CANDIDATE_REASSIGN_TO_JOB = 'CANDIDATE_REASSIGN_TO_JOB'
export const CANDIDATE_REASSIGN_TO_JOB_PENDING = 'CANDIDATE_REASSIGN_TO_JOB_PENDING'
export const CANDIDATE_REASSIGN_TO_JOB_FULFILLED = 'CANDIDATE_REASSIGN_TO_JOB_FULFILLED'
export const CANDIDATE_REASSIGN_TO_JOB_REJECTED = 'CANDIDATE_REASSIGN_TO_JOB_REJECTED'

export type CandidateReAssignToJobRequest = {
  new_job_id: string
  candidate_ids: string[]
}

export type CandidateReAssignToJobResponse = {
  data: {
    message: string
  }
  success: boolean
  statusCode: number
}

export type DeleteCandidateResponse = {
  data: {
    message: string
  }
  success?: boolean
  statusCode?: number
}

export type DeleteCandidateRequest = {
  candidate_ids: string[]
}

export type CandidateBulkUploadRequest = {
  type: string
  file: string
}

export type CandidateBulkUploadResponse = {
  data: {
    message: string
  }
  errors: {
    message: string
  }
  statusCode: number
  success: false
}

export type Candidate = {
  id: number
  name_ar: string
  name_en: string
  name_i18n: string
  current_role: string
  email: string
  phone_number: string
  nationality_id: number
  created_by_id: number
  links: string[]
  organization_id: number
  file_url: string
  created_at: string
  updated_at: string
  job_workflow_stage: jobWorkflowStage
  job: jobs
  activities: Activities[]
  country_id: number
  comments: []
}

export type rejectCandidateResponse = {
  data: {
    message: string
    candidate: Candidate
  }
  success?: boolean
  statusCode?: number
}

// export type rejectCandidateRequest = {
//   candidate_ids: string[]
// }
